export default __webpack_public_path__ + "assets/images/4ddf72251739e348f50c9e72d7c44066-profile.jpg";